"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AccountHandler = _interopRequireDefault(require("./AccountHandler"));
var _ListItemHandler = _interopRequireDefault(require("./ListItemHandler"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//TODO: convert to ts
class ChitEngine {
  constructor() {
    var _this = this;
    _defineProperty(this, "_accountHandler", new _AccountHandler.default());
    _defineProperty(this, "_itemsHandler", new _ListItemHandler.default());
    /**
     * Process all term related information from chit transactions
     * TODO: Currently there is no way to get only term information;
     *       So better to create a new collection called chit terms;
     * @param
     * @param
     * @returns
     */
    _defineProperty(this, "prepareChitTransactions", function () {
      let clearCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise((resolve, reject) => {
        let _tranTypeMap = {};
        let _termDateMap = {};
        let _termCountMap = {};
        let _tranIndexes = [];
        let ac = _this._accountHandler.getActiveAccount();
        console.debug('prepareChitTransactions()->ac', ac);
        _this._itemsHandler.getTranTypesByAcCached("CHIT", clearCache).then(types => {
          // console.debug('getTranTypesByAcCached("CHIT")->types', types);
          _tranTypeMap = types.reduce((obj, type) => {
            obj[type.code] = type.name;
            return obj;
          }, {});
        }).then(() => _this._accountHandler.getAccountTransCached(ac, clearCache)).then(transactions => {
          // console.debug('transactions#1', transactions);
          //inject transaction type name from code
          return transactions.reduce((arr, t) => {
            // convert the tran_type codes
            if (_tranTypeMap.hasOwnProperty(t.type)) {
              t.typeName = _tranTypeMap[t.type];
            }
            // Also prepare term vs date map
            if (t.chit_info) {
              let {
                term,
                date
              } = t.chit_info;
              if (term && date) {
                _termDateMap[term] = date;
                //Count for each term
                if (!_termCountMap[term]) _termCountMap[term] = 0;
                _termCountMap[term]++;
              }
            }
            arr.push(t);
            return arr;
          }, []);
        }).then(transactions => {
          // console.debug("transactions#2", transactions)
          _tranIndexes = transactions.reduce((arr, item) => {
            arr.push({
              _id: item._id,
              sno: item.sno
            });
            return arr;
          }, []);
        }).then(() => {
          resolve({
            tranTypeMap: _tranTypeMap,
            termDateMap: _termDateMap,
            termCountMap: _termCountMap,
            tranIndexes: _tranIndexes
          });
        }).catch(error => {
          console.error(error);
          reject("error");
        });
      });
    });
  }
}
exports.default = ChitEngine;